import React, { PropsWithChildren } from 'react';
import { DefaultApplicationContext } from './default-application-context-provider';

export const ApplicationContext = React.createContext<any | undefined>(undefined);

export enum ApplicationContextEnum {
  PARTNER = 'partner',
  AC = 'ac',
}

export const ApplicationContextProvider = ({
  type,
  children,
}: PropsWithChildren<{ type?: ApplicationContextEnum }>) => {
  switch (type) {
    case ApplicationContextEnum.AC:
      return <DefaultApplicationContext type={ApplicationContextEnum.AC}>{children}</DefaultApplicationContext>;
    default:
      return <DefaultApplicationContext>{children}</DefaultApplicationContext>;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useApplicationContext<ContextValueType = any>() {
  const context = React.useContext(ApplicationContext);

  if (!context) {
    throw new Error('context has not been setup');
  }

  return context as ContextValueType;
}
